var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.29998C1 6.02738 1 5.39063 1.39555 4.99553C1.79065 4.59998 2.4274 4.59998 3.7 4.59998H7.3C8.5726 4.59998 9.20935 4.59998 9.60445 4.99553C10 5.39063 10 6.02738 10 7.29998C10 8.57258 10 9.20933 9.60445 9.60443C9.20935 9.99998 8.5726 9.99998 7.3 9.99998H3.7C2.4274 9.99998 1.79065 9.99998 1.39555 9.60443C1 9.20933 1 8.57258 1 7.29998Z",
    stroke: "#818094"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.80078 4.6V3.7C2.80078 2.98392 3.08524 2.29716 3.59159 1.79081C4.09794 1.28446 4.7847 1 5.50078 1C6.21687 1 6.90362 1.28446 7.40997 1.79081C7.91632 2.29716 8.20078 2.98392 8.20078 3.7V4.6",
    stroke: "#818094",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassLock);
export default __webpack_public_path__ + "static/media/pass-lock.01ae1f3ee7cce07073838b04605ae6b1.svg";
export { ForwardRef as ReactComponent };